import React, { useReducer } from 'react';
import { Button, Modal, Form, Row, Col, Spinner } from 'react-bootstrap';

export function EnhancementRequestModal({ show, setShow, api, setRequestSent }) {

  const loggedInUser = localStorage['username'];
  const initialState = {
    username: { value: loggedInUser, required: true, touched: false, invalid: true, message: '' },
    details: { value: '', required: true, touched: false, invalid: true, message: '' },
    isLoading: false,
    charactersLimit: 2000
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case 'detailsBlurred':
        return {
          ...state,
          [action.payload]: {
            ...state[action.payload],
            touched: true
          }
        }
      case 'detailsChanged':
        return {
          ...state,
          [action.payload.id]: {
            ...state[action.payload],
            value: action.payload.value
          }
        }
      case 'error':
        return {
          ...state,
          error: action.payload
        }
      case 'isLoading':
        return {
          ...state,
          isLoading: action.payload
        }
      case 'resetDetails':
        return {
          ...state,
          details: { value: '', required: true, touched: false, invalid: true, message: '' }
        }
      default:
        throw new Error();
    }
  }

  const [EnhancementRequestState, dispatch] = useReducer(reducer, initialState);

  const handleChange = (event) => {
    const { id, value } = event.target;
    dispatch({ type: 'detailsChanged', payload: { id, value } })
  }

  const handleBlur = (event) => {
    const { id } = event.target;
    dispatch({ type: 'detailsBlurred', payload: id })
  }

  const handleClose = () => {
    setShow(false);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();

    dispatch({ type: 'isLoading', payload: true })

    const details = EnhancementRequestState.details.value;
    const username = EnhancementRequestState.username.value;
    await api.post('api/enhancement-request', { 
      username: username, 
      details: details 
    }).then(response => {
      if (response.status === 200) {
        dispatch({ type: 'isLoading', payload: false })
        dispatch({ type: 'resetDetails' })
        setRequestSent(true)
        setShow(false)
      }
    }
    )
  } 

  const charactersLimitColor = () => {
    return details.value.length === 2000 ? 'red' : 'black';
  }

  const { details, username, isLoading, charactersLimit } = EnhancementRequestState;

  return (
		<Modal show={show} onHide={handleClose}>
			<Form className="p-4">
				<Form.Group as={Row} className="mb-3">
          <Row>
            <Col xs={2}>
              <Form.Label>
                Username: 
              </Form.Label>
            </Col>
            <Col xs={1}>
                {`${username.value}`}
            </Col>
          </Row>
				</Form.Group>
				<Form.Group className="mb-3">
					<Form.Label>Describe your request below:</Form.Label>
					<Form.Control
						as="textarea"
						name="details"
						id="details"
            maxLength={2000}
            placeholder="2000 characters remaining"
						value={details.value}
						onChange={handleChange}
						onBlur={handleBlur}
						rows={4}
            className='m-0 p-0'
					/>
				</Form.Group>
				{isLoading ? (
					<Spinner animation="border" role="status" variant="primary" className='float-end'>
						<span className="visually-hidden">Loading...</span>
					</Spinner>
				) : (
          <>
          <Row>
            <Col className="text-end mt-0 pt-0">
              <span style={{color: charactersLimitColor()}}>{details.value.length}/{charactersLimit}</span>
            </Col>
          </Row>
          <Row>
            <Col className="float-end">
            <Button
              onClick={(event) => handleSubmit(event)}
              variant="primary"
              type="submit"
              className="float-end mt-2"
            >
              Submit
            </Button>
            </Col>
          </Row>
          </>
					
				)}
			</Form>
		</Modal>
	);
}

export default EnhancementRequestModal;
